import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useAppSelector, useAppDispatch } from "../../../app/hooks"
import { getTimeBilingWorksheetForDatatableAsync,setSearchValue,setPageSizeValue ,UpdateTimeBillingWorksheetAsync, updateSorting} from "./timeBillingSlice";
import TimeBillingWorksheetItem from "./TimeBillingWorksheetItem";
import moment from "moment";
import TimeBillingWorksheetFilter from "./TimeBillingWorksheetFilter";
import OffCanvas from '../../../common/OffCanvas';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import { ShowToast } from '../../../common/Toastr';
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { updatePageIdState, getPagePermissionsAsync } from '../../../common/GlobalSlice';
import CustomPagination from "../../../common/Pagination";
import Select, { StylesConfig } from 'react-select';
import { useDebounce } from "../../../_metronic/helpers";
import { getPageSizeArray } from '../../../common/timeLiveFunction';
import { getFilteredList, getValueFromResource } from '../../../common/timeLiveFunction';
import Loader from '../../../common/Loader';
import { truncate } from "fs/promises";
import PageSizeSelect from "../../../common/PageSizeSelect";

const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: 75, minHeight: '36px', height: '36px', padding: '-1px', borderColor: '#EBECF0', marginRight: '0px', fontWeight: '400px', color: '#172B4F' })
}

const TimeBillingWorksheet = () => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const offCanvasList = [
        {
            name:getValueFromResource("Filters", dispatch,t) ,
            width: "500px",
            componentName: <TimeBillingWorksheetFilter t={t} />
        }
    ];
    
    const { timeBillingWorksheetList, isReload, isLoading, currentPage, pageSize, totalItems, start, search, recordsFiltered, selectedRecord,
        optionClientNameValue, optionClientNameText, optionEmployeeNameValue, optionEmployeeNameText, optionProjectValue, optionProjectText,
        optionTaskNameValue,optionTaskNameText, optionBilledValue, optionBilledText, startDate, endDate
    } = useAppSelector((state) => state.timeBillingWorksheet);
    const [showOffCanvas, setShowOffCanvas] = useState(false);
    const [selectedOffCanvas, setSelectedOffCanvas] = useState(offCanvasList[0]); // Store the selected OffCanvas object
    const { pageId, menuList, IsList, IsAdd, IsEdit, IsDelete } = useAppSelector((state) => state.globalState);
    const modelRef = useRef<any>(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const location = useLocation();
    const navigate = useNavigate();
    const currentDate = new Date();
    const [SelectedStartDate, setSelectedStartDate] = useState(() => {
      const newDate = new Date();
      newDate.setMonth(newDate.getMonth() - 2);
      return newDate;
    });  
    const [SelectedEndDate, setSelectedEndDate] = useState(currentDate);

   

    useLayoutEffect(() => {
        const fetchPagePermissions = async () => {
            if (pageId && pageId !== '') {
                const res = await dispatch(getPagePermissionsAsync(pageId));
                if (!res.payload.IsList) {
                    navigate('../error/403');
                }
            } else if (!pageId && menuList && menuList.length > 0) {
                const routeName = location.pathname.split('/').filter(Boolean)[0];
                const foundItem = menuList.find(item => item.SystemCategoryPageFrontEnd === routeName);
                if (foundItem) {
                    const res = await dispatch(getPagePermissionsAsync(foundItem.SystemSecurityCategoryPageId));
                    if (!res.payload.IsList) {
                        navigate('../error/403');
                    }
                } else {
                    navigate('../error/403');
                }
            }
        };

        fetchPagePermissions();
    }, [dispatch, location.pathname, menuList, navigate, pageId]);

    const debouncedSearchTerm = useDebounce(search, 300);

    useEffect(() => {
        const start =  1 * pageSize;
        let SearchParamsValues = `${optionClientNameValue},${optionProjectValue},${optionTaskNameValue},${optionBilledValue},true,${moment(startDate).format('MM-DD-YYYY')},${moment(endDate).format('MM-DD-YYYY')},${optionClientNameText},${optionProjectText},${optionTaskNameText}`;
        dispatch(getTimeBilingWorksheetForDatatableAsync({ currentPage: 1, pageSize: pageSize, start: 0, SearchParamsValues: SearchParamsValues, search: debouncedSearchTerm }));       
    }, [debouncedSearchTerm, isReload]);
    


    const handleOnClickEvent = () => {
        let tempUpdateArray: any[] = [];
        timeBillingWorksheetList.forEach((item: any) => {
            if (item.Billed === true || item.Billed === false) {
                tempUpdateArray.push(item);
            }
        });
      
        dispatch(UpdateTimeBillingWorksheetAsync(tempUpdateArray))
        .unwrap()
        .then((originalPromiseResult) => {
            ShowToast('Time Billing Worksheet Successfully Update', 'Success', "success", "toast-top-right")
        })
        .catch((rejectedValueOrSerializedError) => {
            ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
        })
    }; 

    const handleFilterOnClickEvent = (selectedObject:any) => {
        setSelectedOffCanvas(selectedObject);
        setShowOffCanvas(true);
    }

    const handleFormOnClickEvent = (selectedObject:any) => {   
        setSelectedOffCanvas(selectedObject);
        setShowOffCanvas(true);
    }

    const handlePageChange = (pageNumber: any) => {
        const start = (pageNumber - 1) * pageSize;
        let SearchParamsValues = `${optionClientNameValue},${optionProjectValue},${optionTaskNameValue},${optionBilledValue},true,${moment(startDate).format('MM-DD-YYYY')},${moment(endDate).format('MM-DD-YYYY')},${optionClientNameText},${optionProjectText},${optionTaskNameText}`;
        dispatch(getTimeBilingWorksheetForDatatableAsync({ currentPage: pageNumber, pageSize: pageSize, start: start, SearchParamsValues: SearchParamsValues, search: search }));
    };

    const handleSearch = (event: any) => {
        const { value } = event.target;
        dispatch(setSearchValue(value))
      
    };
    const handlePageSizeChange = (selectedOption: any) => {    
        const { value, label } = selectedOption;
        dispatch(setPageSizeValue(Number(value)));        
        let SearchParamsValues = `${optionClientNameValue},${optionProjectValue},${optionTaskNameValue},${optionBilledValue},true,${moment(startDate).format('MM-DD-YYYY')},${moment(endDate).format('MM-DD-YYYY')},${optionClientNameText},${optionProjectText},${optionTaskNameText}`;
       dispatch(getTimeBilingWorksheetForDatatableAsync({ currentPage: 1, pageSize: Number(value), start: 0, SearchParamsValues: SearchParamsValues, search: search }));
    }

    return (
        <>
            {isLoading && <Loader />} 
            <div className="card card-custom admin-card">
                <div className="card-header card-drop sticky-top bg-white fixed-top">
                    <h3 className="card-title fw-bold headerTitle">
                        {/* {t('Time Billing Worksheet')} */}
                        {getValueFromResource('Time Billing Worksheet',dispatch, t)}
                        </h3>
                    <div className="card-toolbar align-items-center">                       
                        <div className="position-relative">
                            <input
                                value={search}
                                onChange={(e: any) => handleSearch(e)}
                                placeholder=
                                // {t('Search')}
                                {getValueFromResource('Search',dispatch, t)}
                                className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                                data-kt-user-table-filter="search"

                            />
                            <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0" style={{ marginRight: '10px' }}  >
                                <span className="path1"></span>
                                <span className="path2"></span>
                            </i>
                        </div>
                                <div className='h-35px w-1px mx-1'></div>
                                <div className="d-flex align-items-center">
                                {/* <Select
                                    styles={colourStyles}
                                    options={getPageSizeArray()}
                                    value={getPageSizeArray().find((option: any) => option.value == pageSize.toString())}
                                    onChange={handlePageSizeChange}
                                    className='fs-7 fw-normal'
                                /> */}
                                <PageSizeSelect onChange={handlePageSizeChange}/>

                                </div>
                                <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                                <div>
                                    {(timeBillingWorksheetList.length > 0 ) ? (
                                        <CustomPagination
                                            currentPage={currentPage}
                                            onPageChange={handlePageChange}
                                            pageSize={pageSize}
                                            totalItems={totalItems}
                                            start={(currentPage - 1) * pageSize}
                                            t={t}
                                            recordsFiltered={recordsFiltered}
                                        >

                                        </CustomPagination>
                                    ) : null}
                            </div>
                            
                        {(timeBillingWorksheetList.length > 0) &&
                            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        }
                        <a id="kt_OffCanvas"
                            className="btn btn-icon btn-active-light-dark btn-sm ms-0"                           
                            data-tooltip-id="tooltip-Description"
                            data-tooltip-content=
                            // {t("Filters")}
                            {getValueFromResource('Filters',dispatch, t)}
                            data-tooltip-place="bottom">
                            <i className="bi bi-filter fs-3 iconColor"></i>
                        </a>
                        <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        {(timeBillingWorksheetList.length > 0 ) ? (
                            <button type="button"   className="btn btn-primary  btn-bs-btn-font-weight btn-sm"
                                onClick={handleOnClickEvent}>
                                {/* {t('Update')} */}
                                {getValueFromResource('Update',dispatch, t)}
                            </button>):null
                        }                       
                    </div>
                </div>
                {IsList &&
                    // <div className="card-body">
                    <div className="card-Report-body">
                        <div className="table-responsive">
                            <TimeBillingWorksheetItem
                                onhandleFormOnClickEvent={handleFormOnClickEvent}
                                offCanvasObject={offCanvasList[1]}
                                t={t} IsEdit={IsEdit} IsDelete={IsDelete}
                            />
                        </div>
                    </div>
                }
            </div>
            <OffCanvas
                isOpen={showOffCanvas}
                onClose={() => setShowOffCanvas(false)}
                obj={selectedOffCanvas}
            />
        </>
    )
}

export default TimeBillingWorksheet;